
<div class="flex flex-wrap gap-3 xl:gap-2.5 2xl:gap-8 min-[2560px]:gap-12 mb-4">
  <div *ngFor="let stat of stats()"
       class="bg-white shadow-sm border border-gray-100 flex items-center justify-between px-4
              w-[203px] h-[83px]
              2xl:w-[320px] 2xl:h-[130px]
              min-[2560px]:w-[550px] min-[2560px]:h-[220px]
              transition-all duration-300 rounded-sm">

    <div class="flex flex-col justify-center">
      <typography
        variant="body-2"
        weight="semibold"
        color="text-black"
        class="leading-tight 2xl:text-2xl min-[2560px]:text-4xl">
        {{ stat.label }}
      </typography>

      <typography
        variant="body-2"
        weight="semibold"
        color="text-black"
        class="text-lg 2xl:text-4xl min-[2560px]:text-7xl my-1">
        {{ stat.value }}
      </typography>
    </div>

    <div class="bg-black flex items-center justify-center rounded-full
                w-[32px] h-[32px]
                2xl:w-[50px] 2xl:h-[50px]
                min-[2560px]:w-[100px] min-[2560px]:h-[100px]">
      <i [class]="stat.icon + ' text-yellow-500 text-sm 2xl:text-xl min-[2560px]:text-4xl'"></i>
    </div>

  </div>
</div>
